document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menu = document.querySelector('[data-hoh-mobile-menu]');
  const scrim = document.querySelector('[data-hoh-scrim]');
  const menuOpen = document.querySelector('[data-hoh-menu-open]');
  const menuClose = document.querySelector('[data-hoh-menu-close]');
  const searchPanel = document.querySelector('[data-hoh-search-panel]');
  const searchOpens = Array.from(document.querySelectorAll('[data-hoh-search-open]'));
  const searchClose = document.querySelector('[data-hoh-search-close]');

  const lock = () => body.classList.add('locked');
  const unlock = () => body.classList.remove('locked');
  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('open');
    unlock();
  };
  const openMenu = () => {
    if (!menu) return;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('open');
    lock();
  };

  menuOpen?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  scrim?.addEventListener('click', closeMenu);
  menu?.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeMenu));

  const setSearchOpen = (open) => {
    if (!searchPanel) return;
    searchPanel.classList.toggle('open', open);
    searchPanel.setAttribute('aria-hidden', String(!open));
    searchOpens.forEach(button => button.setAttribute('aria-expanded', String(open)));
    if (open) window.setTimeout(() => searchPanel.querySelector('input[name="q"]')?.focus(), 50);
  };

  searchOpens.forEach((button) => {
    button.addEventListener('click', () => setSearchOpen(!searchPanel?.classList.contains('open')));
  });
  searchClose?.addEventListener('click', () => setSearchOpen(false));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
      setSearchOpen(false);
    }
  });

  // Product media gallery
  const productMain = document.querySelector('[data-hoh-product-main]');
  const productThumbs = Array.from(document.querySelectorAll('[data-hoh-product-thumb]'));
  const galleryPrev = document.querySelector('[data-hoh-gallery-prev]');
  const galleryNext = document.querySelector('[data-hoh-gallery-next]');
  const zoomButton = document.querySelector('[data-hoh-product-zoom]');
  const lightbox = document.querySelector('[data-hoh-product-lightbox]');
  const lightboxImage = document.querySelector('[data-hoh-lightbox-image]');
  const lightboxClose = document.querySelector('[data-hoh-lightbox-close]');
  const lightboxPrev = document.querySelector('[data-hoh-lightbox-prev]');
  const lightboxNext = document.querySelector('[data-hoh-lightbox-next]');

  let currentGalleryIndex = Math.max(0, productThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

  const syncLightboxImage = () => {
    if (!lightbox || lightbox.hidden || !lightboxImage || !productMain) return;
    const mainImage = productMain.querySelector('img');
    if (!mainImage) return;
    lightboxImage.src = mainImage.currentSrc || mainImage.src;
    lightboxImage.alt = mainImage.alt || '';
  };

  const showGalleryIndex = (index) => {
    if (!productMain || !productThumbs.length) return;

    const total = productThumbs.length;
    currentGalleryIndex = ((index % total) + total) % total;
    const thumb = productThumbs[currentGalleryIndex];
    const url = thumb?.dataset.image;
    const alt = thumb?.dataset.alt || '';
    const image = productMain.querySelector('img');

    if (image && url) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url;
      image.alt = alt;
    }

    productThumbs.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === currentGalleryIndex);
    });

    syncLightboxImage();
  };

  productThumbs.forEach((btn, index) => {
    btn.addEventListener('click', () => showGalleryIndex(index));
  });

  galleryPrev?.addEventListener('click', () => showGalleryIndex(currentGalleryIndex - 1));
  galleryNext?.addEventListener('click', () => showGalleryIndex(currentGalleryIndex + 1));

  const openLightbox = () => {
    if (!lightbox || !lightboxImage || !productMain) return;
    const image = productMain.querySelector('img');
    if (!image) return;

    lightboxImage.src = image.currentSrc || image.src;
    lightboxImage.alt = image.alt || '';
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hoh-lightbox-open');
    lightboxClose?.focus();
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.classList.remove('is-zoomed');
    document.body.classList.remove('hoh-lightbox-open');
    zoomButton?.focus();
  };

  zoomButton?.addEventListener('click', openLightbox);
  productMain?.querySelector('img')?.addEventListener('click', openLightbox);
  lightboxClose?.addEventListener('click', closeLightbox);
  lightboxPrev?.addEventListener('click', () => showGalleryIndex(currentGalleryIndex - 1));
  lightboxNext?.addEventListener('click', () => showGalleryIndex(currentGalleryIndex + 1));

  lightboxImage?.addEventListener('click', () => {
    lightbox?.classList.toggle('is-zoomed');
  });

  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', (event) => {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showGalleryIndex(currentGalleryIndex - 1);
    if (event.key === 'ArrowRight') showGalleryIndex(currentGalleryIndex + 1);
  });

  // Keep price, availability, primary CTA and sticky mobile CTA in sync with the chosen variant.
  document.querySelectorAll('[data-hoh-variant-select]').forEach((select) => {
    const tiles = Array.from(select.closest('.hoh-variant-field')?.querySelectorAll('[data-hoh-swatch-id]') || []);
    tiles.forEach((tile) => {
      tile.addEventListener('click', () => {
        if (tile.disabled) return;
        const match = Array.from(select.options).find((option) => option.value === tile.dataset.hohSwatchId);
        if (!match || match.disabled) return;
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    const syncVariantUi = () => {
      tiles.forEach((tile) => {
        const selected = tile.dataset.hohSwatchId === select.value;
        tile.classList.toggle('is-selected', selected);
        tile.setAttribute('aria-pressed', String(selected));
      });
      const option = select.options[select.selectedIndex];
      if (!option) return;

      const variantImage = option.dataset.image;
      if (variantImage && productMain) {
        const matchingIndex = productThumbs.findIndex((thumb) => thumb.dataset.image === variantImage);
        if (matchingIndex >= 0) {
          showGalleryIndex(matchingIndex);
        } else {
          const mainImage = productMain.querySelector('img');
          if (mainImage) {
            mainImage.removeAttribute('srcset');
            mainImage.removeAttribute('sizes');
            mainImage.src = variantImage;
            syncLightboxImage();
          }
        }
      }

      const scope = select.closest('[data-hoh-product-form-scope]');
      const price = scope?.querySelector('[data-hoh-current-price]');
      const compare = scope?.querySelector('[data-hoh-compare-price]');
      const add = scope?.querySelector('[data-hoh-add-button]');
      const stickyAdd = scope?.querySelector('[data-hoh-sticky-add-button]');
      const stickyPrice = scope?.querySelector('[data-hoh-sticky-price]');
      const availability = scope?.querySelector('[data-hoh-availability-status]');
      const quantityInput = scope?.querySelector('[data-hoh-product-qty-input]');
      const quantityPlus = scope?.querySelector('[data-hoh-product-qty-plus]');
      const quantityMessage = scope?.querySelector('[data-hoh-quantity-message]');
      const available = option.dataset.available === 'true';
      const inventoryCapped = option.dataset.inventoryCapped === 'true';
      const inventoryTotal = Number.parseInt(option.dataset.inventoryTotal || '0', 10) || 0;
      const cartQuantity = Number.parseInt(option.dataset.cartQuantity || '0', 10) || 0;
      const addMax = Number.parseInt(option.dataset.addMax || '0', 10) || 0;
      const canAdd = available && (!inventoryCapped || addMax > 0);

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;

      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }

      [add, stickyAdd].forEach((button) => {
        if (!button) return;
        button.disabled = !canAdd;
        button.textContent = !available ? 'Sold out' : (inventoryCapped && addMax <= 0 ? 'Max in bag' : 'Add to bag');
      });

      if (availability) {
        availability.classList.toggle('is-sold-out', !available);
        availability.classList.toggle('is-low-stock', available && inventoryCapped && inventoryTotal > 0 && inventoryTotal < 5);
        const label = availability.querySelector('strong');
        if (label) {
          if (!available) label.textContent = 'Sold out';
          else if (inventoryCapped && addMax <= 0) label.textContent = 'All available pieces are already in your bag';
          else if (inventoryCapped && inventoryTotal === 1) label.textContent = 'Last one available';
          else if (inventoryCapped && inventoryTotal > 1 && inventoryTotal < 5) label.textContent = `Only ${inventoryTotal} pieces left`;
          else label.textContent = 'In stock';
        }
      }

      if (quantityInput) {
        quantityInput.dataset.inventoryCapped = String(inventoryCapped);
        quantityInput.dataset.inventoryTotal = String(inventoryTotal);
        quantityInput.dataset.cartQuantity = String(cartQuantity);
        quantityInput.dataset.addMax = String(addMax);

        if (inventoryCapped && addMax > 0) quantityInput.max = String(addMax);
        else quantityInput.removeAttribute('max');

        let quantity = Number.parseInt(quantityInput.value, 10) || 1;
        if (inventoryCapped && addMax > 0 && quantity > addMax) quantity = addMax;
        if (inventoryCapped && addMax <= 0) quantity = 1;
        quantityInput.value = String(Math.max(1, quantity));
        if (quantityPlus) quantityPlus.disabled = inventoryCapped && (addMax <= 0 || quantity >= addMax);

        if (quantityMessage) quantityMessage.hidden = true;
      }
    };

    select.addEventListener('change', syncVariantUi);
    syncVariantUi();
  });
});


document.addEventListener('pointerover', (event) => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const card = event.target.closest('.product-card');
  if (!card) return;
  const image = card.querySelector('[data-secondary-image]');
  if (!image || image.dataset.secondaryLoaded === 'true') return;
  if (image.dataset.src) image.src = image.dataset.src;
  if (image.dataset.srcset) image.srcset = image.dataset.srcset;
  if (image.dataset.sizes) image.sizes = image.dataset.sizes;
  image.dataset.secondaryLoaded = 'true';
});

document.addEventListener('focusin', (event) => {
  const card = event.target.closest('.product-card');
  if (!card) return;
  const image = card.querySelector('[data-secondary-image]');
  if (!image || image.dataset.secondaryLoaded === 'true') return;
  if (image.dataset.src) image.src = image.dataset.src;
  if (image.dataset.srcset) image.srcset = image.dataset.srcset;
  if (image.dataset.sizes) image.sizes = image.dataset.sizes;
  image.dataset.secondaryLoaded = 'true';
});

/* HOH cart drawer Sep 2026 */
(() => {
  const shopRoot = () => window.Shopify?.routes?.root || '/';
  let lastCartTrigger = null;
  let cartRequestBusy = false;

  const getDrawer = () => document.querySelector('[data-hoh-cart-drawer]');

  const updateCartCount = (count) => {
    document.querySelectorAll('.cart-count').forEach((bubble) => {
      bubble.textContent = String(count);
    });
    document.querySelectorAll('[data-hoh-cart-open]').forEach((trigger) => {
      trigger.setAttribute('aria-label', `Cart with ${count} items`);
    });
  };

  const openDrawer = (trigger = null) => {
    const drawer = getDrawer();
    if (!drawer) return;
    if (trigger) lastCartTrigger = trigger;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hoh-cart-drawer-open');
    window.requestAnimationFrame(() => drawer.querySelector('[data-hoh-cart-drawer-close]')?.focus());
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hoh-cart-drawer-open');
    lastCartTrigger?.focus?.();
    lastCartTrigger = null;
  };

  const refreshDrawer = async (shouldOpen = true, trigger = null) => {
    const current = getDrawer();
    if (!current) return false;
    const sectionId = current.dataset.sectionId;
    if (!sectionId) return false;

    const response = await fetch(`${shopRoot()}?section_id=${encodeURIComponent(sectionId)}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Could not refresh bag.');

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const rendered = documentFragment.querySelector('[data-hoh-cart-drawer]');
    if (!rendered) throw new Error('Bag drawer could not be rendered.');

    current.replaceWith(rendered);
    updateCartCount(Number.parseInt(rendered.dataset.cartCount || '0', 10) || 0);
    window.HohInitCartRecommendations?.(rendered);

    if (shouldOpen) openDrawer(trigger);
    return true;
  };

  const changeDrawerLine = async (lineKey, quantity, trigger) => {
    if (!lineKey || cartRequestBusy) return;
    cartRequestBusy = true;
    trigger?.setAttribute('disabled', 'disabled');

    try {
      const response = await fetch(`${shopRoot()}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not update bag.');
      await refreshDrawer(true);
    } catch (error) {
      window.alert(error.message || 'Could not update bag.');
    } finally {
      cartRequestBusy = false;
      trigger?.removeAttribute('disabled');
    }
  };

  document.addEventListener('click', async (event) => {
    const cartOpen = event.target.closest('[data-hoh-cart-open]');
    if (cartOpen) {
      event.preventDefault();
      lastCartTrigger = cartOpen;
      try {
        await refreshDrawer(true, cartOpen);
      } catch (error) {
        window.location.href = cartOpen.href;
      }
      return;
    }

    if (event.target.closest('[data-hoh-cart-drawer-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const productMinus = event.target.closest('[data-hoh-product-qty-minus]');
    const productPlus = event.target.closest('[data-hoh-product-qty-plus]');
    if (productMinus || productPlus) {
      const control = event.target.closest('[data-hoh-product-quantity]');
      const input = control?.querySelector('[data-hoh-product-qty-input]');
      if (!input) return;
      const current = Number.parseInt(input.value, 10) || 1;
      input.value = String(Math.max(1, current + (productPlus ? 1 : -1)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const drawerMinus = event.target.closest('[data-hoh-drawer-qty-minus]');
    const drawerPlus = event.target.closest('[data-hoh-drawer-qty-plus]');
    if (drawerMinus || drawerPlus) {
      const button = drawerMinus || drawerPlus;
      const current = Number.parseInt(button.dataset.currentQuantity || '1', 10) || 1;
      const max = Number.parseInt(button.dataset.inventoryMax || '', 10);
      const hasMax = Number.isFinite(max) && max >= 0;

      if (drawerPlus && hasMax && current >= max) {
        window.alert(max === 1 ? 'Last one available.' : `Only ${max} available in this option.`);
        return;
      }

      const quantity = Math.max(0, current + (drawerPlus ? 1 : -1));
      await changeDrawerLine(button.dataset.lineKey, hasMax ? Math.min(quantity, max) : quantity, button);
      return;
    }

    const drawerRemove = event.target.closest('[data-hoh-drawer-remove]');
    if (drawerRemove) {
      await changeDrawerLine(drawerRemove.dataset.lineKey, 0, drawerRemove);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form');
    if (!form) return;

    const action = form.getAttribute('action') || '';
    const submitter = event.submitter;
    const isAddButton = submitter && (submitter.name === 'add' || submitter.classList.contains('quick-add'));
    if (!isAddButton || !action.includes('/cart/add')) return;

    event.preventDefault();
    if (cartRequestBusy) return;
    cartRequestBusy = true;
    submitter.setAttribute('disabled', 'disabled');

    const originalText = submitter.textContent;
    submitter.textContent = 'Adding…';

    try {
      const formData = new FormData(form);
      const response = await fetch(`${shopRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not add this item to your bag.');

      submitter.textContent = 'Added';
      await refreshDrawer(true, submitter);
    } catch (error) {
      window.alert(error.message || 'Could not add this item to your bag.');
    } finally {
      cartRequestBusy = false;
      submitter.removeAttribute('disabled');
      window.setTimeout(() => {
        submitter.textContent = originalText;
      }, 700);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && getDrawer()?.classList.contains('is-open')) {
      closeDrawer();
    }
  });
})();

/* HOH collection personalization Sep 2026 */
(() => {
  const storageKey = 'hoh_recent_product_interest_v1';

  const readHistory = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeHistory = (items) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 12)));
    } catch (error) {
      return;
    }
  };

  const normalizeTags = (tags) => {
    if (Array.isArray(tags)) return tags.map((tag) => String(tag).trim().toLowerCase()).filter(Boolean);
    return String(tags || '').split('|').map((tag) => tag.trim().toLowerCase()).filter(Boolean);
  };

  const rememberCurrentProduct = () => {
    const node = document.querySelector('[data-hoh-product-context]');
    if (!node) return;

    try {
      const product = JSON.parse(node.textContent || '{}');
      if (!product.handle) return;

      const item = {
        handle: String(product.handle),
        type: String(product.type || '').trim().toLowerCase(),
        tags: normalizeTags(product.tags),
        viewedAt: Date.now()
      };

      const next = [item, ...readHistory().filter((entry) => entry?.handle !== item.handle)];
      writeHistory(next);
    } catch (error) {
      return;
    }
  };

  const scoreCard = (card, history) => {
    const handle = card.dataset.productHandle || '';
    const type = (card.dataset.productType || '').trim().toLowerCase();
    const tags = new Set(normalizeTags(card.dataset.productTags));
    let score = 0;

    history.forEach((view, index) => {
      const weight = Math.max(.35, 1 - (index * .08));
      const viewType = String(view?.type || '').trim().toLowerCase();
      const viewTags = normalizeTags(view?.tags);

      if (handle && handle === view?.handle) score += 2 * weight;
      if (type && viewType && type === viewType) score += 7 * weight;

      let overlaps = 0;
      viewTags.forEach((tag) => {
        if (tags.has(tag)) overlaps += 1;
      });
      score += Math.min(overlaps, 5) * 2.25 * weight;
    });

    return score;
  };

  const initPersonalizedCollectionSort = () => {
    const select = document.querySelector('[data-hoh-sort-select]');
    const grid = document.querySelector('.hoh-collection-page .product-grid');
    const option = select?.querySelector('[data-hoh-personalized-sort]');
    const note = document.querySelector('[data-hoh-personalized-sort-note]');
    if (!select || !grid || !option) return;

    const history = readHistory();
    const cards = Array.from(grid.querySelectorAll('[data-hoh-product-card]'));
    const originalOrder = new Map(cards.map((card, index) => [card, index]));

    if (history.length === 0) {
      option.hidden = true;
      return;
    }

    option.hidden = false;

    const applyRecommended = () => {
      const ranked = cards
        .map((card) => ({
          card,
          score: scoreCard(card, history),
          original: originalOrder.get(card) || 0
        }))
        .sort((a, b) => (b.score - a.score) || (a.original - b.original));

      ranked.forEach(({ card }) => grid.appendChild(card));
      select.value = 'recommended-for-you';
      if (note) note.hidden = false;

      const url = new URL(window.location.href);
      url.searchParams.delete('sort_by');
      url.searchParams.set('hoh_sort', 'recommended');
      window.history.replaceState({}, '', url);
    };

    select.addEventListener('change', () => {
      if (select.value === 'recommended-for-you') {
        applyRecommended();
        return;
      }

      if (note) note.hidden = true;
      const url = new URL(window.location.href);
      url.searchParams.delete('hoh_sort');
      window.history.replaceState({}, '', url);
      select.form?.submit();
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get('hoh_sort') === 'recommended') applyRecommended();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      rememberCurrentProduct();
      initPersonalizedCollectionSort();
    });
  } else {
    rememberCurrentProduct();
    initPersonalizedCollectionSort();
  }
})();

/* HOH Partywear merchandising Oct 2026
   Default draft order: recent sellers first, then higher price, sold-out last.
   Explicit customer sorting (including price low-to-high) always wins. */
(() => {
  const initPartywearMerchandising = () => {
    const grid = document.querySelector('[data-hoh-partywear-merch="true"]');
    if (!grid) return;

    const params = new URLSearchParams(window.location.search);
    if (params.has('sort_by') || params.get('hoh_sort') === 'recommended') return;

    const cards = Array.from(grid.querySelectorAll('[data-hoh-product-card]'));
    if (cards.length < 2) return;

    const number = (value) => Number.parseFloat(value || '0') || 0;

    cards.sort((a, b) => {
      const aAvailable = a.dataset.productAvailable === 'true';
      const bAvailable = b.dataset.productAvailable === 'true';

      if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;

      const aOrders = number(a.dataset.partywearRecentOrders);
      const bOrders = number(b.dataset.partywearRecentOrders);
      const aPrice = number(a.dataset.productPrice);
      const bPrice = number(b.dataset.productPrice);

      const aSeller = aOrders > 0;
      const bSeller = bOrders > 0;

      if (aSeller !== bSeller) return aSeller ? -1 : 1;
      if (aSeller && bSeller && aOrders !== bOrders) return bOrders - aOrders;
      if (aPrice !== bPrice) return bPrice - aPrice;

      return 0;
    });

    cards.forEach((card) => grid.appendChild(card));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPartywearMerchandising);
  } else {
    initPartywearMerchandising();
  }
})();

/* HOH inventory guard Sep 2026 */
(() => {
  const getLimitState = (input) => {
    const capped = input?.dataset.inventoryCapped === 'true';
    const total = Number.parseInt(input?.dataset.inventoryTotal || '0', 10) || 0;
    const cartQuantity = Number.parseInt(input?.dataset.cartQuantity || '0', 10) || 0;
    const addMax = Number.parseInt(input?.dataset.addMax || '0', 10) || 0;
    return { capped, total, cartQuantity, addMax };
  };

  const showProductLimit = (scope, input) => {
    const message = scope?.querySelector('[data-hoh-quantity-message]');
    if (!message) return;
    const { capped, cartQuantity, addMax } = getLimitState(input);
    if (!capped) {
      message.hidden = true;
      return;
    }

    if (addMax <= 0) {
      message.textContent = cartQuantity > 0
        ? `You already have ${cartQuantity} in your bag. No more are currently available.`
        : 'This option is no longer available.';
    } else if (addMax === 1) {
      message.textContent = cartQuantity > 0
        ? `You already have ${cartQuantity} in your bag. Only 1 more can be added.`
        : 'Only 1 can be added.';
    } else {
      message.textContent = cartQuantity > 0
        ? `You already have ${cartQuantity} in your bag. Only ${addMax} more can be added.`
        : `Only ${addMax} can be added.`;
    }
    message.hidden = false;
  };

  const syncProductQuantity = (scope, requestedValue, showMessage = false) => {
    const input = scope?.querySelector('[data-hoh-product-qty-input]');
    const plus = scope?.querySelector('[data-hoh-product-qty-plus]');
    const message = scope?.querySelector('[data-hoh-quantity-message]');
    if (!input) return true;

    const { capped, addMax } = getLimitState(input);
    let value = Number.parseInt(requestedValue ?? input.value, 10);
    if (!Number.isFinite(value)) value = 1;
    value = Math.max(1, value);

    if (capped && addMax <= 0) {
      input.value = '1';
      if (plus) plus.disabled = true;
      if (showMessage) showProductLimit(scope, input);
      return false;
    }

    if (capped && value > addMax) {
      input.value = String(addMax);
      if (plus) plus.disabled = true;
      if (showMessage) showProductLimit(scope, input);
      return false;
    }

    input.value = String(value);
    if (plus) plus.disabled = capped && value >= addMax;
    if (message && !showMessage) message.hidden = true;
    return true;
  };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-hoh-product-qty-minus]');
    const plus = event.target.closest('[data-hoh-product-qty-plus]');
    if (!minus && !plus) return;

    const scope = event.target.closest('[data-hoh-product-form-scope]');
    const input = scope?.querySelector('[data-hoh-product-qty-input]');
    if (!scope || !input) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const current = Number.parseInt(input.value, 10) || 1;
    const next = Math.max(1, current + (plus ? 1 : -1));
    syncProductQuantity(scope, next, Boolean(plus));
  }, true);

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('[data-hoh-product-qty-input]');
    if (!input) return;
    const scope = input.closest('[data-hoh-product-form-scope]');
    syncProductQuantity(scope, input.value, true);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('[data-hoh-product-qty-input]');
    if (!input) return;
    const scope = input.closest('[data-hoh-product-form-scope]');
    syncProductQuantity(scope, input.value, true);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('form');
    const scope = form?.closest?.('[data-hoh-product-form-scope]');
    const submitter = event.submitter;
    if (!form || !scope || !submitter || submitter.name !== 'add') return;

    const input = scope.querySelector('[data-hoh-product-qty-input]');
    if (!input) return;

    const valid = syncProductQuantity(scope, input.value, true);
    if (!valid) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const initialize = () => {
    document.querySelectorAll('[data-hoh-product-form-scope]').forEach((scope) => {
      const input = scope.querySelector('[data-hoh-product-qty-input]');
      if (input) syncProductQuantity(scope, input.value, false);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();

/* HOH cart recommendations Sep 2026 */
(() => {
  const recommendationsPath = () => `${window.Shopify?.routes?.root || '/'}recommendations/products.json`;

  const money = (cents) => {
    const amount = (Number(cents) || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency
      }).format(amount);
    } catch (error) {
      return `£${amount.toFixed(2)}`;
    }
  };

  const productUrl = (product) => {
    if (product?.url) return product.url;
    return `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product?.handle || '')}`;
  };

  const imageUrl = (product) => {
    const raw = typeof product?.featured_image === 'string'
      ? product.featured_image
      : (product?.featured_image?.src || product?.images?.[0] || '');
    if (!raw) return '';

    try {
      const url = new URL(raw, window.location.origin);
      url.searchParams.set('width', '360');
      return url.toString();
    } catch (error) {
      return raw;
    }
  };

  const buildCard = (product) => {
    const article = document.createElement('article');
    article.className = 'hoh-cart-reco-card';

    const link = document.createElement('a');
    link.className = 'hoh-cart-reco-card__link';
    link.href = productUrl(product);

    const media = document.createElement('div');
    media.className = 'hoh-cart-reco-card__media';

    const src = imageUrl(product);
    if (src) {
      const image = document.createElement('img');
      image.src = src;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    }

    const copy = document.createElement('div');
    copy.className = 'hoh-cart-reco-card__copy';

    const title = document.createElement('h3');
    title.className = 'hoh-cart-reco-card__title';
    title.textContent = product.title || '';

    const price = document.createElement('p');
    price.className = 'hoh-cart-reco-card__price';
    price.textContent = money(product.price);

    const view = document.createElement('span');
    view.className = 'hoh-cart-reco-card__view';
    view.textContent = 'View product →';

    copy.append(title, price, view);
    link.append(media, copy);
    article.appendChild(link);
    return article;
  };

  const loadRecommendations = async (container) => {
    if (!container || container.dataset.recommendationsLoaded === 'true') return;
    container.dataset.recommendationsLoaded = 'true';

    const productId = container.dataset.productId;
    if (!productId) return;

    const exclude = new Set(
      String(container.dataset.excludeProductIds || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean)
    );

    try {
      const url = new URL(recommendationsPath(), window.location.origin);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '8');
      url.searchParams.set('intent', 'related');

      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;

      const payload = await response.json();
      const products = Array.isArray(payload?.products) ? payload.products : [];
      const selected = products
        .filter((product) => product?.available && !exclude.has(String(product.id)))
        .slice(0, 3);

      if (!selected.length) return;

      const grid = container.querySelector('[data-hoh-cart-recommendations-grid]');
      if (!grid) return;

      selected.forEach((product) => grid.appendChild(buildCard(product)));
      container.hidden = false;
    } catch (error) {
      return;
    }
  };

  const init = (root = document) => {
    const containers = root.matches?.('[data-hoh-cart-recommendations]')
      ? [root]
      : Array.from(root.querySelectorAll?.('[data-hoh-cart-recommendations]') || []);

    containers.forEach((container) => {
      if (container.dataset.recommendationsObserved === 'true') return;
      container.dataset.recommendationsObserved = 'true';

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0]?.isIntersecting) return;
          observer.disconnect();
          loadRecommendations(container);
        }, { rootMargin: '220px 0px' });
        observer.observe(container);
      } else {
        loadRecommendations(container);
      }
    });
  };

  window.HohInitCartRecommendations = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();